// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2KnP-","footer":"ModalFilter_footer__1LO-2"};